import { Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";

interface ContentItemProps {
  titulo: string;
  descricao: string;
  conta?: string;
  banco?: string;
}

export function ContentItem(props: ContentItemProps) {
  return (
    <Flex direction="column" mr="3">
      <Flex color="#768398" fontSize="12px">
        {props.titulo}
      </Flex>
      <Flex fontSize="12px">{props.descricao}</Flex>
      <Flex gap="4px">
        <Flex color={colors.blueishGray50} fontSize="12px">
          {props.banco}
        </Flex>
        <Flex color={colors.blueishGray50} fontSize="12px">
          {props.conta}
        </Flex>
      </Flex>
    </Flex>
  );
}
